"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clogHosts = exports.cookiesDomain = exports.video = exports.cps = exports.admin = exports.bfe = exports.gateway = exports.web = exports.makeUnifyDomain = exports.hostInfo = exports.hostCheck = void 0;
// 判断测试环境正则
var testHostReg = /(233|235|test|test2|test3|local|dev)\./i;
// 判断预发环境正则
var preHostReg = /^staging-/i;
// 判断管理后台正则
var adminHostReg = /(^|\W)admin(\.\w+)?\.mistong\.com(:|$)/i;
// 判断是否是CPS平台（ewt360域名，但是走的是类似管理后台逻辑）
var cpsHostReg = /(^|\W)cps\./i;
var cpsDomainReg = /\.ewt360\.com(:|$)/i;
// 判断是否是本地开发环境
var localHostReg = /:\d+$/i;
function hostCheck(host) {
    var isTest = testHostReg.test(host);
    var isAdmin = adminHostReg.test(host);
    var isCPS = !isAdmin && cpsHostReg.test(host) && (isTest || cpsDomainReg.test(host));
    return {
        isTest: isTest,
        isPre: preHostReg.test(host),
        isAdmin: isAdmin,
        isCPS: isCPS,
        // 是否是前台
        isFront: !isAdmin && !isCPS,
        isLocal: localHostReg.test(host),
    };
}
exports.hostCheck = hostCheck;
exports.hostInfo = hostCheck(location.host);
// 根据指定的域名前缀生成通用的完整域名
var makeUnifyDomain = function (originDomain) {
    var domain = exports.hostInfo.isTest
        ? ".test.mistong.com"
        : exports.hostInfo.isAdmin
            ? ".mistong.com"
            : ".ewt360.com";
    if (exports.hostInfo.isPre) {
        return "//staging-".concat(originDomain).concat(domain);
    }
    return "//".concat(originDomain).concat(domain);
};
exports.makeUnifyDomain = makeUnifyDomain;
exports.web = (0, exports.makeUnifyDomain)("web");
exports.gateway = (0, exports.makeUnifyDomain)("gateway");
exports.bfe = exports.hostInfo.isTest
    ? "//test-bfe.mistong.com"
    : (0, exports.makeUnifyDomain)("bfe");
exports.admin = (0, exports.makeUnifyDomain)("admin");
exports.cps = (0, exports.makeUnifyDomain)("cps");
exports.video = exports.hostInfo.isAdmin ? exports.admin : exports.hostInfo.isCPS ? exports.cps : exports.web;
exports.cookiesDomain = (function () {
    var domain = ".ewt360.com";
    if (exports.hostInfo.isTest || exports.hostInfo.isAdmin) {
        domain = ".mistong.com";
    }
    return domain;
})();
exports.clogHosts = {
    clog: "//clog.ewt360.com",
    dlog: "//dlog.ewt360.com",
    iplog: "//101.37.78.197:8081",
};
